import type { RouteObject } from 'react-router';
import { RouteError } from '@/components/RouteError';
import { legalRoutes } from '@/legal/routes';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { LandingPage } from './LandingPage';
import { LandingShell } from './LandingShell';

const lazyPage = (loader: () => Promise<{ Component: React.ComponentType }>) => ({ lazy: loader });

/** The brand site: the home page and guides. Sign-in happens in each space or in the console. */
export function buildLandingRoutes(): RouteObject[] {
  return [
    {
      errorElement: <RouteError />,
      children: [
        { index: true, element: <LandingPage /> },
        {
          element: <LandingShell />,
          children: [
            {
              path: '/guias',
              ...lazyPage(async () => ({
                Component: (await import('@/guides/GuidesIndexPage')).GuidesIndexPage,
              })),
            },
            {
              path: '/guias/:slug',
              ...lazyPage(async () => ({
                Component: (await import('@/guides/GuidePage')).GuidePage,
              })),
            },
            ...legalRoutes(),
          ],
        },
        { path: '*', element: <NotFoundPage /> },
      ],
    },
  ];
}
